import { useMemo, useState } from 'react';
import { Gift, AlertTriangle, X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useApp } from '@/components/hooks/useApp';

const MS_PER_DAY = 86400000;

// Aviso de la prueba gratuita. Se enseña a QUIEN TIENE PRUEBA, que es lo que
// dice `trial_ends_at` — no según cómo se dio de alta.
//
// Antes miraba `plan_source === 'promo_launch'`, que era el único origen que
// escribía fecha de fin. Desde que la invitación también da prueba (90 días,
// frente a los 30 del autoservicio), esa condición dejaba sin aviso justo a
// los invitados: los primeros clientes, que no verían cuánto les queda.
//
// `trial_ends_at` nulo significa "sin prueba" —una cuenta normal, sin
// caducidad— y ahí no hay nada que avisar.
export default function TrialBanner() {
  const { company } = useApp();
  const [dismissed, setDismissed] = useState(false);

  const trialEndsAt = company?.trial_ends_at;

  const daysLeft = useMemo(() => {
    if (!trialEndsAt) return null;
    const ms = new Date(trialEndsAt).getTime();
    // Una fecha ilegible no debe pintar "te quedan NaN días".
    if (Number.isNaN(ms)) return null;
    return Math.ceil((ms - Date.now()) / MS_PER_DAY);
  }, [trialEndsAt]);

  if (dismissed || daysLeft === null) return null;

  const expired = daysLeft <= 0;

  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        'flex items-center justify-center gap-3 px-6 py-2 text-sm font-medium text-center',
        expired
          ? 'bg-amber-50 text-amber-800 border-b border-amber-200 dark:bg-amber-950/40 dark:text-amber-200 dark:border-amber-900'
          : 'bg-primary/10 text-primary border-b border-primary/20',
      )}
    >
      {expired ? (
        <AlertTriangle className="w-4 h-4 shrink-0" aria-hidden="true" />
      ) : (
        <Gift className="w-4 h-4 shrink-0" aria-hidden="true" />
      )}

      {expired ? (
        <span>
          Tu prueba gratuita ha terminado.{' '}
          <a href="mailto:hello@verix.es" className="underline font-semibold hover:no-underline">
            Contacta con nosotros para continuar.
          </a>
        </span>
      ) : (
        <span>
          Prueba gratuita: te quedan {daysLeft} día{daysLeft === 1 ? '' : 's'}
        </span>
      )}

      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Cerrar aviso"
        className="ml-1 shrink-0 rounded p-0.5 opacity-70 transition-opacity hover:opacity-100"
      >
        <X className="w-3.5 h-3.5" aria-hidden="true" />
      </button>
    </div>
  );
}
